import { toCanonicalJsonString } from "../../lib/utils/toCanonicalJsonString";
import { DbSignedLicense, sanitizeLicense, SignedLicense } from "./License";

export const PermittedPublicLicenseSignatureVerificationKeys: JsonWebKey[]= [
	{
		"key_ops": [
			"verify"
		],
		"ext": true,
		"crv": "Ed25519",
		"x": "ZE0lUMb_tbkxvZcH_XQFgFTR76yNWS7O9igL86lTrSk",
		"kty": "OKP"
	},
]

export const PermittedPublicLicenseVerificationKeysByXPoint = new Map<string, JsonWebKey>(
	PermittedPublicLicenseSignatureVerificationKeys.map( p => [p.x, p] as [string, JsonWebKey])
);

const isPermittedLicenseSignatureVerificationKey = (publicKey: JsonWebKey): boolean => {
	if (publicKey.x == null) return false;
	const matchesX = PermittedPublicLicenseVerificationKeysByXPoint.get( publicKey.x );
	if (matchesX == null) return false;
	const keys = [...new Set<keyof JsonWebKey>([...Object.keys(publicKey), ...Object.keys(matchesX)] as (keyof JsonWebKey)[])].filter( k => k != "key_ops" && k != "oth");
	const fieldsMatch = keys.every( k => publicKey[k] === matchesX[k]) &&
		(!("key_ops" in publicKey) || (publicKey.key_ops?.length === 1 && publicKey.key_ops[0] === "verify"));
	return fieldsMatch;
}




export const throwIfSignedLicenseDoesNotHaveValidSignature = async (
	signedLicense: SignedLicense | DbSignedLicense
) => {
	const { signatureHex, algorithm, jwkKeyForVerifyingThisLicense } = signedLicense;
	const licenseJson = toCanonicalJsonString(sanitizeLicense(signedLicense));
	const licenseJsonBuffer = new TextEncoder().encode(licenseJson);
	const signature = new Uint8Array(signatureHex.match(/.{1,2}/g)?.map(byte => parseInt(byte, 16)) || []);
	const {x} = jwkKeyForVerifyingThisLicense;
	if (x == null) {
		throw new Error('Public key JWK does not contain x coordinate');
	}
	if (!isPermittedLicenseSignatureVerificationKey(jwkKeyForVerifyingThisLicense)) {
		throw new Error(`Public key is not permitted`);
	}
	const publicKey = await crypto.subtle.importKey('jwk', jwkKeyForVerifyingThisLicense, algorithm, false, ['verify']);
	const signatureValidated = await crypto.subtle.verify(algorithm, publicKey, signature, licenseJsonBuffer);
	if (!signatureValidated) {
		throw new Error('Signature validation failed');
	}
	return signedLicense;
}

export const validateSignedLicense = async (
	signedLicense: SignedLicense
): Promise<boolean> => {
	try {
		await throwIfSignedLicenseDoesNotHaveValidSignature(signedLicense);
		return true;
	} catch {
		return false;
	}
}